<template>
	<div class="privacyPolicy">
		<xl-dialog v-model="dialogVisible" :title="$t(title)" width="50%" modal top="0">
			<div class="ppHtml" v-html="privacyHtml" v-loading="getInfoLoading"></div>
		</xl-dialog>
	</div>
</template>

<script setup>
import Login from '@/api/pub';
import { $rdoLang } from '@/assets/common/common.js';
import { useLang } from '@/hooks/lang';
import { XlDialog } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
const { $t } = useLang( '@shining3d/app' );
const privacyHtml = ref( '' );
const props = defineProps({
	type: { type: String, default: 'privacy' },
	title: {
		type: String,
		default: 'home.privacyText'
	},
	source: { type: String, default: 'dentalCloud' }
});
const cookie = VueCookieNext;
const getInfoLoading = ref( false );
const dialogVisible = ref( false );
const getInfo = () => {
	getInfoLoading.value = true;
	Login.getOigpc( $rdoLang( cookie.getCookie( 'lang' )), 'index', props.type, props.source ).
		then(( res ) => {
			privacyHtml.value = res.result;
			getInfoLoading.value = false;
		}).
		catch(() => {
			getInfoLoading.value = false;
		});
};
defineExpose({ dialogVisible, getInfo });
</script>

<style scoped lang="scss">
.privacyPolicy {
	:deep(.el-overlay-dialog) {
		display: flex;
		align-items: center;

		.xl-dialog {
			margin-bottom: 0;
		}

		.ppHtml {
			max-height: 80vh;
			min-height: 100px;
			overflow: auto;
      word-break: break-word;
		}
	}
}
</style>
